import { StyleSheet, ViewProps, View } from 'react-native'
import { Trans } from 'react-i18next'
import { Color, Radius, shortLocalizedTime, Spacing, Text } from 'zens-storybook'
import { useStore } from 'zens-store'
import { parse } from 'date-fns'
import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, ReactElement, RefAttributes } from 'react'

import ScheduleSlider, { ScheduleSliderRef } from '../schedule/slider'
import { TimeZoneConflict } from '../location'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  value: {
    marginBottom: Spacing.S,
  },
  skeletonSlider: {
    height: 28,
    backgroundColor: Color.sleepingGrey,
    borderRadius: Radius.S,
    marginTop: 22,
    marginBottom: 26,
  },
})

interface Data {
  startAt: string
  endAt: string
}

interface Props extends ViewProps {
  companyId: number
  backgroundColor?: string
  disabled?: boolean
  value?: Data
  onChange?: (value: Data) => void
}

const CompanyWorkingHours = forwardRef<ScheduleSliderRef, Props>((props, ref) => {
  const { companyId, style, ...otherProps } = props
  const { i18n } = useStore()
  const time = `${shortLocalizedTime(
    parse(props.value?.startAt || '0:00', 'HH:mm', new Date()),
    i18n.language,
  )} - ${shortLocalizedTime(parse(props.value?.endAt || '0:00', 'HH:mm', new Date()), i18n.language)}`

  return (
    <View style={[styles.container, style]}>
      <Text style={styles.value}>
        <Trans>
          {/* @ts-expect-error Typing of vars in trans not working correctly  */}
          Currently set to <Text level={5}>{{ time }}</Text>
        </Trans>
      </Text>
      <ScheduleSlider {...otherProps} ref={ref} />
      <TimeZoneConflict companyId={companyId} />
    </View>
  )
}) as ForwardRefExoticComponent<PropsWithoutRef<Props> & RefAttributes<ScheduleSliderRef>> & {
  Skeleton: (props: SkeletonProps) => ReactElement
}

interface SkeletonProps extends ViewProps {}
CompanyWorkingHours.Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text.Skeleton />
      <View style={styles.skeletonSlider} />
    </View>
  )
}

export default CompanyWorkingHours
